import { API } from '@/components/api/shared/api'
import { registrationApiFormatter } from '@/components/api/registrationApi/apiFormatter'
import { RegistrationApiFormatterInput } from '@/components/api/registrationApi/types'
import { ServiceType, SERVICE_TYPES } from '@/components/constants'

// DEV-3303: 電話番号の入力時点で、即架電の事前告知を PF に依頼する。
// 対象LP・対象地域の判定と重複排除は PF 側で行う。
// 登録の妨げにならないよう結果は待たず、失敗しても console.error だけで例外を外に出さない。
export const sendPreEntryNotification = (
    data: RegistrationApiFormatterInput,
    service: ServiceType = SERVICE_TYPES.FOODSLABO
): void => {
    try {
        const formatted = registrationApiFormatter(data)
        const body = {
            mobile: formatted.mobile,
            source_url: formatted.source_url,
            last_name: formatted.last_name,
            first_name: formatted.first_name,
            age: formatted.age,
            situation: formatted.situation,
            registration_area_name: formatted.registration_area_name,
            job_change_interest: formatted.job_change_interest,
        }

        fetch(API.ENDPOINTS.PRE_ENTRY_NOTIFICATION(service), {
            method: 'POST',
            headers: {
                'Content-Type': API.HEADERS.CONTENT_TYPE,
                Accept: API.HEADERS.CONTENT_TYPE,
            },
            body: JSON.stringify(body),
            // 入力直後に登録して画面が遷移しても送信を続ける。
            // このケース（入力から登録までが最短）こそ計測したいため、落とせない
            keepalive: true,
        })
            .then((response) => {
                if (!response.ok) {
                    console.error(`Pre-entry notification failed: ${response.status}`)
                }
            })
            .catch((error: unknown) => {
                console.error('Pre-entry notification failed', error)
            })
    } catch (error: unknown) {
        console.error('Pre-entry notification failed', error)
    }
}
